// Style
window.$ = jQuery;
import "../sass/main.scss";
import "./functions/main-page";
import "./custom_m/custom_m";

import {Swiper, Pagination, Navigation, Thumbs, Controller, Autoplay} from 'swiper';

//import "swiper/swiper-bundle.min.js"



$(document).ready(function () {
    $('select').select2({
        minimumResultsForSearch: -1
    });

    $('body').toggleClass('unloaded');

    const stickyBar = $('.hahawoman');

    if (stickyBar && stickyBar.length > 0) {
        const stickyBarHeight = stickyBar.innerHeight();
        const stickyBarOffsetTop = stickyBar.offset().top;

        if (stickyBarOffsetTop > window.innerHeight + window.scrollY + stickyBarHeight) {
            $('.hahawoman').addClass('active');
        } else {
            $(window).on("scroll", function () {
                if (window.scrollY + window.innerHeight >= stickyBarHeight + stickyBarOffsetTop || stickyBarOffsetTop > window.innerHeight + window.scrollY + stickyBarHeight)
                    $(".hahawoman").addClass("active");
                else
                    $(".hahawoman").removeClass("active");
            });
        }
    }

    $('.hamburger').on("click", function () {
        $(this).toggleClass('is-active');
    })

    $(window).one('scroll', function() {
        $('select').select2({
            minimumResultsForSearch: -1
        });

        $('#location').select2({
            minimumResultsForSearch: -1
        });
    });


    $('.hamburger').on("click", function () {
        $('.sidenav').toggleClass('active');
        $('body').toggleClass('sidenav-active');
    });

    $('#sort-by').change(function () {
        var selectedOption = $(this).val();
        $('#sort-order').val(selectedOption);
        $('#property-search-form').submit()
    });

    $('.switch-buttons .row').click(function () {
        var templateValue = $(this).hasClass('rod') ? 'rod' : 'grid';
        $('.switch-buttons .row').removeClass('active');
        $(this).addClass('active');
        $('#template').val(templateValue);
        $('#property-search-form').submit()
    });


    let swiper = new Swiper(".mySwiper", {
        modules: [Pagination,Navigation],
        spaceBetween: 27,
        slidesPerView: 4.5,
    });


    let swiper2 = new Swiper(".mySwiper2", {
        modules: [Pagination, Navigation],
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },


        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    let swiperResidence = new Swiper(".mySwiper-residence", {
        modules: [Pagination, Navigation],
        spaceBetween: 27,
        slidesPerView: 4.5,
        initialSlide:'5',

    });

    let sancho = new Swiper(".sancho", {
        modules: [Pagination, Navigation],
        spaceBetween: 32,
        slidesPerView: 3,
        breakpoints: {
            0: {
                spaceBetween: 15,
                slidesPerView: 1.1,
            },
            993: {
                spaceBetween: 32,
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: ".swiper-button-nextxa",
            prevEl: ".swiper-button-prevxa",
        },

        pagination: {
            el: ".swiper-paginationxa",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    let swiper2Residence = new Swiper(".mySwiper2-residence", {
        modules: [Pagination, Navigation],
        spaceBetween: 26,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiperResidence: swiperResidence,
        },


        pagination: {
            el: ".swiper-pagination-residence",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    let thumbs = document.querySelectorAll('.mySwiper .swiper-slide');
    thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
            swiper2.slideTo(index);
        });
    });

    $('.instruction').insertAfter($('.mySwiper'));
    $('.instruction-residence').insertAfter($('.mySwiper-residence'));
});

$(document).ready(function() {
    function initSliderInwestycja() {
        if (!$('body').hasClass('single-investment')) {
            if ($(window).width() < 992) {
                $('.slider-inwestycje').addClass('swiper-mySwiper');
                $('.articles').addClass('swiper-wrapper');
                $('.article').addClass('swiper-slide');
                var swiperInwestycje = new Swiper('.slider-inwestycje', {
                    modules: [Navigation, Pagination],
                    slidesPerView: 1.08,
                    spaceBetween: 15,
                    loop: false,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        },
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            } else {
                $('.slider-inwestycje').removeClass('swiper-mySwiper');
                $('.articles').removeClass('swiper-wrapper');
//                $('.article').removeClass('swiper-slide');
            }
        }
    }

    // Initialize slider on document ready
    initSliderInwestycja();

    // Add resize event listener
    $(window).on('resize', function() {
        // Re-initialize slider on window resize
        initSliderInwestycja();
    });

    if (document.querySelector('body').classList.contains('single-investment')) {
        const textContainer = document.querySelector('.mine .text .main');
        const showMoreButton = document.querySelector('.mine .text .skryj');

        if (!textContainer || !showMoreButton) return;

        if (textContainer.offsetHeight < 926) return;

        showMoreButton.classList.add('enabled');
        textContainer.classList.add('enabled');
    }

    $('.skryj').click(function() {
        var text = $(this).text();
        if (text === "Czytaj więcej ") {
            $(this).text("Schowaj");
        } else {
            $(this).text("Czytaj więcej ");
        }
        $('.main').toggleClass('active');
    });
});

$(document).ready(function() {
    function initSliderAktualnosci() {
        if ($(window).width() < 992) {
            $('.slider-aktualnosci').addClass('swiper-mySwiper');
            $('.articles').addClass('swiper-wrapper');
            $('.article').addClass('swiper-slide');
            var swiperAktualnosci = new Swiper('.slider-aktualnosci', {
                modules:[Navigation,Pagination],
                slidesPerView: 1,
                loop: false,
                spaceBetween: 15,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        } else {
            $('.slider-inwestycje').removeClass('swiper-mySwiper');
            $('.articles').removeClass('swiper-wrapper');
//            $('.article').removeClass('swiper-slide');
        }
    }

    // Initialize slider on document ready
    initSliderAktualnosci();

    // Add resize event listener
    $(window).on('resize', function() {
        // Re-initialize slider on window resize
        initSliderAktualnosci();
    });
});


$(document).ready(function() {
    function initSliderSwiper() {
        if ($(window).width() < 1100) {
            $('.standard-stage').addClass('swiper-mySwiper');
            $('.etapy').addClass('swiper-wrapper');
            $('.rozne-etapy').addClass('swiper-slide');
            const swiperStandardy = new Swiper('.standard-stage', {
                modules:[Autoplay],
                slidesPerView: 2,
                spaceBetween:30,
                loop: false,
                // autoplay: {
                //     delay: 3000,
                // },

            });
        } else {
            $('.standard-stage').removeClass('swiper-mySwiper');
            $('.etapy').removeClass('swiper-wrapper');
//            $('.rozne-etapy').removeClass('swiper-slide');
        }
    }
    initSliderSwiper();




    $(window).on('resize', function() {

        initSliderSwiper();
    });

    let gallery = new Swiper(".galleryd", {
        modules: [Pagination, Navigation],
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-nextx",
            prevEl: ".swiper-button-prevx",
        },


        pagination: {
            el: ".swiper-paginationx",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    let swipers = new Swiper(".mySwipers", {
        modules: [Pagination, Navigation],
        spaceBetween: 27,
        slidesPerView: 5,
        breakpoints: {
            0: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            993: {
                slidesPerView: 5,
                spaceBetween: 15,
            },
        },
    });

    let swiper2s = new Swiper(".mySwiper2s", {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-nextxx",
            prevEl: ".swiper-button-prevxx",
        },
        thumbs: {
            swiper: swipers,
        },

        pagination: {
            el: ".swiper-paginationxx",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    });

    let thumbss = document.querySelectorAll('.mySwipers .swiper-slide');
    thumbss.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
            swiper2s.slideTo(index);
        });
    });

    $('.instructionz').insertAfter($('.mySwipers'));

    if ($(window).width() <= 992) {
        $('.page-template-page-standardy .instruction').insertAfter($('.mySwiper2'));
        $('.page-template-page-standardy .instruction-residence').insertAfter($('.mySwiper2-residence'));
    }
});

$(document).ready(function() {
    $('.close').click(function() {
        $('._li').toggleClass('active');
    });
    $('.facebook').click(function() {
        $('._li').toggleClass('active');
    });
});

$(document).ready(function() {
    let previousScroll = 0;

    document.addEventListener('scroll', function() {
        if (window.innerWidth > 992) return;

        const navbar = document.querySelector('nav.navbar');

        if (!navbar) return;

        const navbarHeight = navbar.offsetHeight;
        
        if (window.scrollY < previousScroll && window.scrollY != 0 && window.scrollY >= navbarHeight) {
            navbar.classList.add('navbar-sticky');
            navbar.classList.remove('navbar-sticky--hidden');
            document.querySelector('body').style.paddingTop = `${navbarHeight}px`;
        } else if (window.scrollY != 0 && window.scrollY >= navbarHeight) {
            navbar.classList.add('navbar-sticky--hidden');
        } else if (window.scrollY == 0) {
            navbar.classList.remove('navbar-sticky');
            navbar.classList.remove('navbar-sticky--hidden');
            document.querySelector('body').style.paddingTop = '0px';
        }

        previousScroll = window.scrollY;
    });
});

const setCookie = (name, value, expiry) => {
    const today = new Date();
    const ex = new Date(today.getTime() + 24 * 3600 * 1000 * expiry);
    document.cookie = name + "=" + escape(value) + "; path=/; expires=" + ex.toGMTString();
}

const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

const acceptCookies = () => {
    const cookiesInfoBar = document.querySelector('.cookies');

    if (!cookiesInfoBar) return;

    cookiesInfoBar.querySelector('button.accept-cookies').addEventListener('click', function() {
        setCookie('cookies-accepted', true, 999999);
        document.querySelector('body').setAttribute('data-cookies-accepted', true);
    });
}

$(document).ready(acceptCookies);

const validatePhoneNumberInForms = () => {
    const phoneNumberInputs = document.querySelectorAll('input[type="tel"]');
    const permittedKeys = ['Delete', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

    if (!phoneNumberInputs || Array.from(phoneNumberInputs).length < 1) return;

    phoneNumberInputs.forEach(input => {
        input.addEventListener('keydown', function(e) {
            if (!isNaN(e.key)) return;
            else if (permittedKeys.includes(e.key)) return;

            e.preventDefault();
        });
    });
}

$(document).ready(validatePhoneNumberInForms);

const replaceEllipsis = () => {
    let articles;

    if (document.querySelector('body').classList.contains('home')) articles = document.querySelectorAll('.slider-aktualnosci .articles .article');
    else if (document.querySelector('body').classList.contains('page-template-page-aktualnosci')) articles = document.querySelectorAll('.articles .article');

    if (!articles || Array.from(articles).length < 1) return;

    articles.forEach(article => {
        const articleExcerpt = article.querySelector('.content p');
        
        if (articleExcerpt.scrollHeight <= articleExcerpt.clientHeight) return;

        articleExcerpt.classList.add('ellipsis-changed');
    });
}

$(document).ready(replaceEllipsis);

$(document).ready(function() {
    // homepage carousel touch not working before using nav fix

    let x = new bootstrap.Carousel('#carouselExampleCaptions');
    let y = new bootstrap.Carousel('#carouselExampleIndicators');

    // homepage carousel jumps with different heights fix
    let maxHeight = 0;

    document.querySelectorAll('#carouselExampleIndicators .container').forEach(carouselItem => {
        if (window.innerWidth > 992) return;

        if (maxHeight < carouselItem.offsetHeight) maxHeight = carouselItem.offsetHeight;

        carouselItem.classList.remove('before-load');
    });

    document.querySelectorAll('#carouselExampleIndicators .container').forEach(carouselItem => {
        if (window.innerWidth > 992) return;
        
        carouselItem.style.height = `${maxHeight}px`;
    });
})

